import { useContext } from "react";
import { UserDirectoryContext } from "hhn-commons";
import { AVATAR_SIZE } from "../../utils/AvatarUtils";
import DisplayAvatarImage, {
  DisplayAvatarImageType,
} from "../DisplayAvatarImage";

interface IMessageUserAvatarProp extends DisplayAvatarImageType {
  userId: string;
}

const UserImage = ({ userId }: IMessageUserAvatarProp) => {
  const { userDirectory } = useContext(UserDirectoryContext);
  const user = userDirectory.getUserInfo(userId);

  return (
    <DisplayAvatarImage
      src={user?.image}
      alt={user?.title}
      avatarSize={AVATAR_SIZE.SMALL}
    />
  );
};

export default UserImage;
